import { Redo2, Undo2 } from "lucide-react";

import { IconButton } from "@/components/ui/icon-button";

export function UndoRedoControls({
  canUndo,
  canRedo,
  isBusy,
  onUndo,
  onRedo,
}: {
  canUndo: boolean;
  canRedo: boolean;
  isBusy: boolean;
  onUndo: () => void;
  onRedo: () => void;
}) {
  return (
    <div className="flex items-center gap-1" role="group" aria-label="Edit history">
      <IconButton
        label="Undo"
        icon={Undo2}
        variant="outline"
        shortcut="⌘Z / Ctrl+Z"
        onClick={onUndo}
        disabled={!canUndo || isBusy}
      />
      <IconButton
        label="Redo"
        icon={Redo2}
        variant="outline"
        shortcut="⇧⌘Z / Ctrl+Y"
        onClick={onRedo}
        disabled={!canRedo || isBusy}
      />
    </div>
  );
}
